import React from 'react'

const PurchaseReports = () => {
  return (
    <>
      <div className="pagetitle">
        <h1>Purchase Reports</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="#">Home</a></li>
            <li className="breadcrumb-item">Purchases & Suppliers</li>
            <li className="breadcrumb-item active">Purchase Reports</li>
          </ol>
        </nav>
      </div>
      <section className="section">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">
                  <i className="bi bi-file-earmark-bar-graph me-2"></i>
                  Purchase Reports
                </h5>
                <p>View comprehensive purchase reports and analytics. Analyze purchase trends, supplier performance, and spending patterns.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default PurchaseReports

